'use strict';

var Polyglot = require('node-polyglot');

export default new Polyglot({
  phrases: window.PHRASES,
  allowMissing: true,
});
